import supabaseClient from '@/api/supabaseClient';
import { FunctionsHttpError, SupabaseClient } from '@supabase/supabase-js';
import { useMutation } from '@tanstack/react-query';
import { CreateChildUserRequest } from '@/types/request/CreateChildUserRequest';
import { queryClient } from '@/main';

const useCreateChildUser = () => {
  const client = supabaseClient;

  const mutationFn = async (request: CreateChildUserRequest) => {
    return createChildUser(client, request);
  };

  return useMutation({
    mutationFn,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['child-users'] });
    },
  });
};

export default useCreateChildUser;

async function createChildUser(client: SupabaseClient, request: CreateChildUserRequest): Promise<void> {
  const { error } = await client.functions.invoke('create_child_user', {
    body: { ...request },
  });

  if (error && error instanceof FunctionsHttpError) {
    const errorMessage = await error.context.json();

    if (errorMessage.errors && errorMessage.errors.length > 0) {
      throw new Error(errorMessage.errors[0]);
    }

    throw new Error(error.message);
  }

  return;
}
